import { render, staticRenderFns } from "./ExamenCargado.vue?vue&type=template&id=5dfe7fb8&"
import script from "./ExamenCargado.vue?vue&type=script&lang=js&"
export * from "./ExamenCargado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports